var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseOffFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#E6E9E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 15.8333C30.4 14.8208 31.2059 14 32.2 14C33.1941 14 34 14.8208 34 15.8333V34.1667C34 35.1792 33.1941 36 32.2 36C31.2059 36 30.4 35.1792 30.4 34.1667V15.8333ZM16 15.8333C16 14.8208 16.8059 14 17.8 14C18.7941 14 19.6 14.8208 19.6 15.8333V34.1667C19.6 35.1792 18.7941 36 17.8 36C16.8059 36 16 35.1792 16 34.1667V15.8333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseOffFill);
export default __webpack_public_path__ + "static/media/pause-off-fill.4869c2a4cdfbba606d84f2d57bef7350.svg";
export { ForwardRef as ReactComponent };